module.exports = {};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_iterators.js
// module id = 54
// module chunks = 0